import { ROLLOUTS } from '@fiverr-private/listing_experiments';
import { AI_BANNER_SUB_CATEGORY_IDS, AI_BANNER_NESTED_SUB_CATEGORY_IDS } from './constants';

export const shouldShowAiBanner = (categoryIds, rollouts: { [key: string]: boolean }) => {
    if (!rollouts[ROLLOUTS.CROWS_AI_DIRECTOR_BANNER]) {
        return false;
    }

    const { subCategoryId, nestedSubCategoryId } = categoryIds || {};
    if (AI_BANNER_SUB_CATEGORY_IDS.includes(subCategoryId)) return true;
    if (nestedSubCategoryId && AI_BANNER_NESTED_SUB_CATEGORY_IDS.includes(nestedSubCategoryId)) return true;
    return false;
};
